export default __webpack_public_path__ + "static/media/certification6.dbbac1ac.jpg";